(function () {
  const header = document.querySelector("[data-cc-app-header]");
  if (!header) return;

  const cartLink = header.querySelector("[data-cc-nav-cart]");
  const cartCountEl = cartLink?.querySelector("[data-cc-cart-count]");
  const cartLabel = cartLink?.dataset.ccCartLabel || "Cart";

  function renderCartCount(count) {
    if (!cartLink || !cartCountEl) return;
    const n = Math.max(0, Number(count) || 0);
    if (n > 0) {
      cartCountEl.textContent = ` (${n})`;
      cartCountEl.hidden = false;
      cartLink.setAttribute("aria-label", `${cartLabel}, ${n} items`);
    } else {
      cartCountEl.textContent = "";
      cartCountEl.hidden = true;
      cartLink.setAttribute("aria-label", cartLabel);
    }
  }

  function syncCartCountFromServer() {
    fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => renderCartCount(cart.item_count))
      .catch(() => {});
  }

  document.addEventListener("cart:update", (event) => {
    const cart = event.detail?.resource;
    if (cart && typeof cart.item_count === "number") {
      renderCartCount(cart.item_count);
      return;
    }
    syncCartCountFromServer();
  });

  window.addEventListener("pageshow", (event) => {
    if (event.persisted) syncCartCountFromServer();
  });

  function setHeaderHeight() {
    const h = header.offsetHeight;
    document.body.style.setProperty("--header-height", `${h}px`);
    document.body.style.setProperty("--header-group-height", `${h}px`);
  }

  function updateStuckState() {
    header.classList.toggle("is-stuck", window.scrollY > 4);
  }

  setHeaderHeight();
  updateStuckState();
  window.addEventListener("resize", setHeaderHeight);
  window.addEventListener("scroll", updateStuckState, { passive: true });
  if (typeof ResizeObserver !== "undefined") {
    new ResizeObserver(setHeaderHeight).observe(header);
  }
})();
